import React from 'react';
import PropTypes from 'prop-types';

import { AButton } from '../atoms';

export default function ODestructiveButtons({
	saveEnabled,
	showDelete,
	onDelete,
	onSave,
	className,
}) {
	let deleteButton;

	if (showDelete) {
		deleteButton = (
			<AButton
				type="destructive"
				value="Delete"
				className="cms-spacing"
				onClick={onDelete}
			/>
		);
	}

	return (
		<section className={`o-cms-destructive-buttons ${className}`}>
			{deleteButton}
			<AButton
				value="Save"
				onClick={onSave}
				disabled={!saveEnabled}
			/>
		</section>
	);
}

ODestructiveButtons.propTypes = {
	onDelete: PropTypes.func,
	onSave: PropTypes.func.isRequired,
	saveEnabled: PropTypes.bool,
	showDelete: PropTypes.bool,
	className: PropTypes.string,
};

ODestructiveButtons.defaultProps = {
	onDelete: undefined,
	saveEnabled: false,
	showDelete: false,
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.destructive-buttons.js